import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

// Map routes to page titles
const pageTitles: Record<string, string> = {
  '/admin': 'Dashboard',
  '/admin/dashboard': 'Dashboard',
  '/admin/map': 'Map View',
  '/admin/providers': 'Service Providers',
  '/admin/customers': 'Customers',
  '/admin/listings': 'Listings',
  '/admin/reviews': 'Reviews',
  '/admin/orders': 'Orders',
  '/admin/config': 'Configuration',
  '/admin/notifications': 'Send Notifications',
  '/admin/notifications-center': 'Notifications Center',
  '/admin/leads': 'Leads',
  '/admin/engagement': 'SP Engagement Analytics',
  '/admin/meta-ads-landing': 'Meta Ads Landing',
  '/admin/categories': 'Categories',
  '/admin/ai-ops': 'Command Center',
};

const AdminLayout = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Close mobile sidebar on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Get current page title
  const pageTitle = pageTitles[location.pathname] || 'Admin';

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden admin-layout">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <Header title={pageTitle} onMenuClick={() => setSidebarOpen(true)} />

        {/* Page Content */}
        <main className="h-[calc(100vh-4rem)] h-[calc(100dvh-4rem)] overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
